/* eslint-disable */
import { CURRENCY_CODE } from './strings';
import { deviceInfoPayload } from './deviceInformation';
import { getMerchantGroupId } from './CommonLogic';
import { getMerchantGroupIdByCountry } from './mid';
export const payerAuthPayload = (offerdata: any, contactInfo: any, token: any, ipAddr?: any, pinLeadDetails?: any) => {
    const defaultMerchantGroupId = getMerchantGroupId();

    const roomTypes = offerdata?.roomTypes && offerdata?.roomTypes[0] || '';
    const offerCountry = roomTypes?.property?.country || '';
    const merchantGroupId = getMerchantGroupIdByCountry(offerCountry) || defaultMerchantGroupId;
    const currentDate = new Date();
    const formattedDate = currentDate?.toISOString() || '';
    const paymentId = `${contactInfo?.lastName}-${formattedDate}-${roomTypes?.roomTypeDescription}`;
    const depositAmt = (roomTypes?.depositAmount?.includes('$') && roomTypes?.depositAmount.split('$')) || '';
    const totalAmt = depositAmt && depositAmt[1];
    const deviceInfo = deviceInfoPayload();
    deviceInfo.ipAddress = ipAddr;
    const payloadRequest: any = {
        tokenInformation: {
            jti: '',
            transientTokenJwt: token,
        },
        clientReferenceInformation: {
            code: 'WEB_PBT',
            merchantGroupId: merchantGroupId,
            paymentId: paymentId,
            referenceId: '',
        },
        orderInformation: {
            amountDetails: {
                totalAmount: totalAmt,
                currency: CURRENCY_CODE,
            },
        },
    };
    return payloadRequest;
};
